import React from 'react';

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: "#581845"}}>
      <div className="container">
        <a className="navbar-brand text-white" href="/">
          <h3>Metronic</h3>
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse " id="navbarNav">
          <ul className="navbar-nav ms-auto ">
            <li className="nav-item mx-2">
              <a className="nav-link text-white" href="/">Home</a>
            </li>
            <li className="nav-item mx-2">
              <a className="nav-link text-white" href="/about">About</a>
            </li>
            <li className="nav-item mx-2">
              <a className="nav-link text-white" href="/services">Services</a>
            </li>
            <li className="nav-item mx-2">
              <a className="nav-link text-white" href="/contact">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
